import React from "react";
import {Controller, useFormContext} from "react-hook-form";
import {Box, Colors} from "@bounce/shared/ui";
import {TextField} from "../../../ui/components";
import FieldLabel from "./FieldLabel";
import FormSection from "./FormSection";
import {BaseFlowFormValues} from "./schema";

const DetailsSection = () => {
  const {control} = useFormContext<BaseFlowFormValues>();

  return (
    <FormSection title="Details">
      <Box>
        <FieldLabel required>Name</FieldLabel>
        <Controller
          name="name"
          control={control}
          render={({field: {ref, ...field}, fieldState}) => (
            <TextField
              {...field}
              inputRef={ref}
              fullWidth
              size="small"
              placeholder="Test name"
              error={!!fieldState.error}
              sx={{backgroundColor: Colors.bw.white, borderRadius: "8px"}}
            />
          )}
        />
      </Box>
    </FormSection>
  );
};

export default DetailsSection;
